import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _dec2, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formValueSelector, initialize, reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import billingValidation from './billingValidation';
import { LLTextField, LLCheckbox } from 'components/FormElements';
import { Button } from '../';
import * as styles from './BillingForm.scss';
var StripeCardBillingForm = (_dec = reduxForm({
  form: 'billing',
  validate: billingValidation
}), _dec2 = connect(function (state) {
  var billingFormSelector = formValueSelector('billing');
  return {
    active: state.form.billing.active,
    contract: state.contract,
    billingError: state.billing.billingError,
    showMonthsPaidFor: billingFormSelector(state, 'showMonthsPaidFor'),
    monthsPaidFor: billingFormSelector(state, 'monthsPaidFor')
  };
}, {
  initialize: initialize
}), _dec(_class = _dec2(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(StripeCardBillingForm, _Component);

  var _super = _createSuper(StripeCardBillingForm);

  // eslint-disable-line react/prefer-stateless-function
  function StripeCardBillingForm(props) {
    var _this;

    _classCallCheck(this, StripeCardBillingForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "showAddressFields", function () {
      if (_this.props.contract && _this.state.useContractAddress) {
        var address = _this.props.contract.Address;

        _this.setState({
          useContractAddress: false
        });

        _this.props.initialize('billing', {
          name: "".concat(_this.props.contract.firstName, " ").concat(_this.props.contract.lastName),
          address1: address.address1,
          address2: address.address2,
          locality: address.locality,
          region: address.region,
          postcode: address.postcode
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "hideAddressFields", function () {
      if (_this.state.useContractAddress === false) {
        _this.setState({
          useContractAddress: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref) {
      var input = _ref.input,
          placeholder = _ref.placeholder,
          type = _ref.type,
          className = _ref.className,
          _ref$meta = _ref.meta,
          active = _ref$meta.active,
          touched = _ref$meta.touched,
          error = _ref$meta.error,
          rest = _objectWithoutProperties(_ref, ["input", "placeholder", "type", "className", "meta"]);

      switch (type) {
        case 'select':
          return /*#__PURE__*/React.createElement(LLTextField, _extends({}, input, {
            placeholder: placeholder,
            type: type,
            className: className,
            id: input.name,
            errorText: !active && touched && error && /*#__PURE__*/React.createElement("span", null, error),
            style: {
              width: '100%'
            }
          }));
          break;

        case 'checkbox':
          return /*#__PURE__*/React.createElement(LLCheckbox, _extends({}, input, {
            label: placeholder,
            className: className,
            name: input.name,
            id: input.name
          }));
          break;

        default:
          return /*#__PURE__*/React.createElement(LLTextField, _extends({}, rest || {}, input, {
            placeholder: placeholder,
            type: type,
            className: className,
            id: input.name,
            errorText: !active && touched && error && /*#__PURE__*/React.createElement("span", null, error),
            style: {
              width: '100%'
            }
          }));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderAddressFields", function () {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
        className: styles.billingHeader
      }, "Billing Address"), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "name",
        component: _this.renderInput,
        type: "text",
        placeholder: "Name",
        stripe: "name",
        className: "form-control",
        styles: styles
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "address1",
        component: _this.renderInput,
        type: "text",
        placeholder: "Address 1",
        stripe: "address_line1",
        className: "form-control",
        styles: styles
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "address2",
        component: _this.renderInput,
        type: "text",
        placeholder: "Address 2",
        stripe: "address_line2",
        className: "form-control",
        styles: styles
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "locality",
        component: _this.renderInput,
        type: "text",
        placeholder: "City",
        stripe: "address_city",
        className: "form-control",
        styles: styles
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-3"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "region",
        component: _this.renderInput,
        type: "text",
        placeholder: "State",
        stripe: "address_state",
        className: "form-control",
        styles: styles
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-3"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "postcode",
        component: _this.renderInput,
        type: "text",
        stripe: "address_zip",
        styles: styles,
        className: "form-control",
        placeholder: "Billing Zip"
      }))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderPaymentFields", function () {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
        className: styles.billingHeader,
        style: {
          marginTop: 36
        }
      }, "Payment Information"), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(Field, {
        "data-private": "lipsum",
        name: "cardNumber",
        component: _this.renderInput,
        type: "text",
        placeholder: "Card Number",
        stripe: "number",
        className: "form-control",
        styles: styles
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-4"
      }, /*#__PURE__*/React.createElement(Field, {
        "data-private": "lipsum",
        name: "expMonth",
        component: _this.renderInput,
        type: "text",
        stripe: "exp_month",
        size: "2",
        styles: styles,
        placeholder: "Expiration Month (MM)",
        className: "form-control"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-4"
      }, /*#__PURE__*/React.createElement(Field, {
        "data-private": "lipsum",
        name: "expYear",
        component: _this.renderInput,
        type: "text",
        stripe: "exp_year",
        size: "2",
        styles: styles,
        placeholder: "Expiration Year (YY)",
        className: "form-control"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-4"
      }, /*#__PURE__*/React.createElement(Field, {
        "data-private": "lipsum",
        name: "cvc",
        component: _this.renderInput,
        type: "text",
        stripe: "cvc",
        styles: styles,
        className: "form-control",
        placeholder: "CVC"
      }))));
    });

    _this.state = {
      useContractAddress: true
    };
    return _this;
  }

  _createClass(StripeCardBillingForm, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var contract = this.props.contract;
      console.log("contract =  ".concat(contract));
      console.log(contract);
      var address = contract.hasOwnProperty('Address') ? contract.Address : null;
      this.props.initialize('billing', {
        name: contract.firstName && contract.lastName ? "".concat(this.props.contract.firstName, " ").concat(this.props.contract.lastName) : '',
        address1: address ? address.address1 : '',
        address2: address ? address.address2 : '',
        locality: address ? address.locality : '',
        region: address ? address.region : '',
        postcode: address ? address.postcode : '',
        monthsPaidFor: address ? 1 : ''
      });
    }
  }, {
    key: "render",
    value: function render() {
      var handleSubmit = this.props.handleSubmit;
      return /*#__PURE__*/React.createElement("div", null, this.renderAddressFields(), this.renderPaymentFields());
    }
  }]);

  return StripeCardBillingForm;
}(Component), _defineProperty(_class2, "propTypes", {
  active: PropTypes.string,
  asyncValidating: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  dirty: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  initialize: PropTypes.func.isRequired
}), _temp)) || _class) || _class);
export { StripeCardBillingForm as default };